import { useEffect, useState } from 'react';
import { apiUrl } from '../config/api';
import { apiFetch } from '../utils/session';

/**
 * <img> for files that require the Bearer token (e.g. Aadhaar scans), which a plain
 * `src` URL cannot send. Fetches as a blob and shows it via an object URL.
 */
export default function AuthImage({ path, alt, className, linkToFull = false }) {
  const [src, setSrc] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl = '';
    let cancelled = false;
    setSrc('');
    setFailed(false);
    (async () => {
      try {
        const res = await apiFetch(apiUrl(path));
        if (!res.ok) throw new Error('load failed');
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (failed) {
    return className ? (
      <span className={className} aria-hidden />
    ) : (
      <span className="verify-muted am-muted">Could not load image</span>
    );
  }
  if (!src) {
    return className ? (
      <span className={className} aria-hidden />
    ) : (
      <span className="verify-muted am-muted">Loading…</span>
    );
  }

  const img = <img className={className} src={src} alt={alt} />;
  return linkToFull ? (
    <a href={src} target="_blank" rel="noreferrer">
      {img}
    </a>
  ) : (
    img
  );
}
